import { render, staticRenderFns } from "./ViewGrades.vue?vue&type=template&id=bf35367e&scoped=true&"
import script from "./ViewGrades.vue?vue&type=script&lang=js&"
export * from "./ViewGrades.vue?vue&type=script&lang=js&"
import style0 from "./ViewGrades.vue?vue&type=style&index=0&id=bf35367e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf35367e",
  null
  
)

export default component.exports